import React, {useEffect, useState} from 'react';
import moment from 'moment';
import {observer} from "mobx-react";
import {courseApi} from "../api/courseApi";
import {Menu} from "../menu/menu";
import {MeetingRecordingsList} from "./meetingRecordingsList";
import homeStyle from '../main/home.scss';
import style from '../teachers/teacherMediaRecordings.scss';

export const RecentMeetings = observer(function RecentMeetings() {
  const [meetings, setMeetings] = useState(null);

  useEffect(() => {
    (async () => {
      const recentMeetings = await courseApi.searchTaughtMeetingsInPeriod(
        moment().subtract(48, 'hours'),
        moment()
      );
      setMeetings([...recentMeetings].sort((a, b) => moment(b.startTime).valueOf() - moment(a.startTime).valueOf()));
    })();
  }, []);

  return (
    <div className={homeStyle.home}>
      <Menu/>
      <div className={homeStyle.list}>
        <div className={style.header}>Recent meetings (past 48h)</div>
        <MeetingRecordingsList meetings={meetings} emptyMessage="No meetings taught in the past 48 hours"/>
      </div>
    </div>
  );
});